[
  "一",
  "七",
  "三",
  "上",
  "下",
  "不",
  "丐",
  "丑",
  "世",
  "丘",
  "丟",
  "並",
  "中",
  "串",
  "丹",
  "乃",
  "久",
  "之",
  "乎",
  "乏",
  "乒",
  "乓",
  "乖",
  "乘",
  "九",
  "乞",
  "也",
  "乳",
  "乾",
  "亂",
  "了",
  "予",
  "二",
  "五",
  "亞",
  "亡",
  "交",
  "亦",
  "享",
  "亭",
  "亮",
  "人",
  "什",
  "仇",
  "今",
  "介",
  "仍",
  "仔",
  "他",
  "付",
  "仙",
  "以",
  "仰",
  "仲",
  "任",
  "份",
  "仿",
  "企",
  "伍",
  "伏",
  "伐",
  "伙",
  "估",
  "伴",
  "伶",
  "伺",
  "但",
  "佈",
  "位",
  "低",
  "佐",
  "佑",
  "佔",
  "佛",
  "作",
  "你",
  "佩",
  "併",
  "使",
  "來",
  "侈",
  "例",
  "侍",
  "供",
  "依",
  "侮",
  "侯",
  "侵",
  "侶",
  "侷",
  "便",
  "係",
  "促",
  "俄",
  "俊",
  "俐",
  "俘",
  "俠",
  "信",
  "修",
  "俯",
  "俱",
  "倆",
  "倉",
  "個",
  "倍",
  "們",
  "倒",
  "倖",
  "候",
  "倚",
  "借",
  "倡",
  "倦",
  "倫",
  "值",
  "假",
  "偉",
  "做",
  "健",
  "側",
  "偵",
  "偶",
  "偽",
  "傀",
  "傅",
  "傍",
  "傑",
  "傘",
  "備",
  "傢",
  "催",
  "傭",
  "傲",
  "傳",
  "債",
  "傻",
  "傾",
  "僅",
  "像",
  "僑",
  "僕",
  "僥",
  "僱",
  "僵",
  "僻",
  "儀",
  "億",
  "儉",
  "儒",
  "儘",
  "償",
  "儡",
  "優",
  "儲",
  "允",
  "元",
  "兄",
  "充",
  "兆",
  "兇",
  "先",
  "克",
  "兌",
  "免",
  "兒",
  "兜",
  "入",
  "全",
  "兩",
  "八",
  "六",
  "兮",
  "典",
  "兼",
  "再",
  "冒",
  "冠",
  "冤",
  "冥",
  "冬",
  "冰",
  "冷",
  "准",
  "凋",
  "凌",
  "凍",
  "凝",
  "几",
  "凡",
  "凰",
  "凱",
  "凳",
  "凶",
  "凸",
  "凹",
  "函",
  "刀",
  "刃",
  "分",
  "刊",
  "刑",
  "划",
  "列",
  "判",
  "刨",
  "利",
  "刪",
  "刮",
  "到",
  "制",
  "刷",
  "券",
  "刻",
  "則",
  "削",
  "前",
  "剎",
  "剔",
  "剖",
  "剛",
  "剝",
  "剩",
  "剪",
  "副",
  "割",
  "創",
  "劃",
  "劈",
  "劉",
  "劍",
  "劑",
  "功",
  "加",
  "劣",
  "助",
  "努",
  "劫",
  "勁",
  "勃",
  "勇",
  "勉",
  "勒",
  "動",
  "勘",
  "務",
  "募",
  "勤",
  "勵",
  "勻",
  "勾",
  "勿",
  "匆",
  "化",
  "北",
  "匙",
  "匠",
  "匪",
  "匯",
  "匿",
  "區",
  "十",
  "千",
  "午",
  "半",
  "卑",
  "卒",
  "卓",
  "協",
  "南",
  "博",
  "占",
  "卦",
  "印",
  "危",
  "卵",
  "卷",
  "卸",
  "卻",
  "厚",
  "厲",
  "去",
  "參",
  "叉",
  "友",
  "叔",
  "叛",
  "叢",
  "另",
  "叨",
  "叩",
  "叫",
  "召",
  "叭",
  "叮",
  "可",
  "台",
  "史",
  "司",
  "吃",
  "各",
  "合",
  "吊",
  "同",
  "名",
  "后",
  "吏",
  "君",
  "吝",
  "吟",
  "吧",
  "吩",
  "含",
  "吻",
  "吼",
  "吾",
  "呀",
  "呂",
  "呈",
  "告",
  "呢",
  "周",
  "味",
  "呵",
  "呻",
  "呼",
  "咀",
  "和",
  "咎",
  "咐",
  "咒",
  "咕",
  "咖",
  "咦",
  "咪",
  "咬",
  "咱",
  "咳",
  "咽",
  "哀",
  "哄",
  "哇",
  "哎",
  "員",
  "哥",
  "哦",
  "哩",
  "哪",
  "哭",
  "哲",
  "哺",
  "哼",
  "唆",
  "售",
  "唯",
  "唱",
  "唾",
  "啄",
  "商",
  "啊",
  "問",
  "啞",
  "啟",
  "啡",
  "啤",
  "啦",
  "啼",
  "善",
  "喇",
  "喉",
  "喊",
  "喘",
  "喚",
  "喜",
  "喝",
  "喧",
  "喪",
  "喬",
  "單",
  "喲",
  "喻",
  "嗅",
  "嗆",
  "嗇",
  "嗎",
  "嗓",
  "嗚",
  "嗜",
  "嗦",
  "嗨",
  "嗯",
  "嗽",
  "嘉",
  "嘍",
  "嘔",
  "嘛",
  "嘩",
  "嘮",
  "嘯",
  "嘲",
  "嘴",
  "嘻",
  "嘿",
  "噁",
  "噓",
  "噢",
  "噪",
  "噴",
  "嚀",
  "嚇",
  "嚏",
  "嚨",
  "嚮",
  "嚴",
  "嚷",
  "嚼",
  "囉",
  "囊",
  "囑",
  "囚",
  "四",
  "回",
  "困",
  "圈",
  "國",
  "圍",
  "園",
  "圖",
  "團",
  "圾",
  "均",
  "坊",
  "坎",
  "坐",
  "坑",
  "坡",
  "坤",
  "坦",
  "坪",
  "坷",
  "垂",
  "垃",
  "垢",
  "埃",
  "埋",
  "城",
  "埔",
  "域",
  "執",
  "培",
  "堂",
  "堆",
  "堡",
  "堤",
  "堪",
  "報",
  "場",
  "堵",
  "塌",
  "塑",
  "塔",
  "塗",
  "塘",
  "塞",
  "塵",
  "墅",
  "墊",
  "墓",
  "墜",
  "增",
  "墟",
  "墨",
  "墮",
  "墳",
  "墾",
  "壁",
  "壇",
  "壓",
  "壘",
  "壞",
  "壟",
  "壤",
  "士",
  "壽",
  "夏",
  "夕",
  "外",
  "多",
  "夜",
  "夢",
  "夥",
  "大",
  "天",
  "太",
  "夾",
  "奇",
  "奈",
  "奉",
  "奏",
  "契",
  "奔",
  "奕",
  "套",
  "奠",
  "奢",
  "奧",
  "奪",
  "奮",
  "女",
  "奴",
  "奸",
  "她",
  "好",
  "如",
  "妄",
  "妒",
  "妓",
  "妖",
  "妙",
  "妝",
  "妥",
  "妨",
  "妮",
  "妳",
  "妹",
  "姆",
  "姊",
  "始",
  "姐",
  "姓",
  "委",
  "姦",
  "姨",
  "姪",
  "姻",
  "姿",
  "威",
  "娘",
  "娛",
  "娟",
  "婉",
  "婚",
  "婦",
  "婷",
  "婿",
  "媒",
  "媚",
  "媳",
  "媽",
  "嫂",
  "嫉",
  "嫌",
  "嫩",
  "嬉",
  "嬌",
  "嬰",
  "嬸",
  "子",
  "孕",
  "字",
  "孟",
  "季",
  "孤",
  "孩",
  "學",
  "宅",
  "宇",
  "安",
  "宋",
  "宏",
  "宗",
  "官",
  "宙",
  "定",
  "宜",
  "客",
  "宰",
  "宴",
  "家",
  "容",
  "宿",
  "寂",
  "寄",
  "密",
  "富",
  "寒",
  "寞",
  "察",
  "寡",
  "寢",
  "寧",
  "寨",
  "審",
  "寫",
  "寬",
  "寵",
  "寺",
  "封",
  "射",
  "將",
  "專",
  "尋",
  "對",
  "導",
  "小",
  "少",
  "尚",
  "尤",
  "尬",
  "尷",
  "尺",
  "尼",
  "尿",
  "屁",
  "居",
  "屆",
  "屈",
  "屍",
  "屎",
  "屏",
  "屑",
  "屜",
  "屠",
  "屢",
  "層",
  "履",
  "屬",
  "岔",
  "岩",
  "峭",
  "峰",
  "島",
  "峽",
  "崇",
  "崖",
  "崗",
  "崩",
  "嶄",
  "嶺",
  "嶼",
  "巡",
  "巢",
  "工",
  "巧",
  "巨",
  "巫",
  "差",
  "已",
  "巷",
  "巾",
  "市",
  "帆",
  "希",
  "帕",
  "帖",
  "帝",
  "帥",
  "師",
  "席",
  "帳",
  "帶",
  "帽",
  "幅",
  "幕",
  "幟",
  "幣",
  "幫",
  "平",
  "年",
  "幸",
  "幻",
  "幼",
  "幽",
  "幾",
  "庇",
  "床",
  "序",
  "底",
  "度",
  "庭",
  "康",
  "庸",
  "廁",
  "廂",
  "廈",
  "廉",
  "廊",
  "廓",
  "廚",
  "廠",
  "廢",
  "廣",
  "廳",
  "延",
  "廷",
  "建",
  "弄",
  "弊",
  "弓",
  "引",
  "弘",
  "弛",
  "弟",
  "弦",
  "弧",
  "強",
  "彈",
  "彌",
  "彙",
  "彥",
  "彬",
  "彰",
  "影",
  "彷",
  "役",
  "彼",
  "彿",
  "往",
  "征",
  "很",
  "徊",
  "律",
  "後",
  "徐",
  "徑",
  "徒",
  "徘",
  "徨",
  "復",
  "循",
  "徬",
  "徵",
  "德",
  "徹",
  "忌",
  "忘",
  "忙",
  "忠",
  "快",
  "忽",
  "忿",
  "怎",
  "怒",
  "怕",
  "怖",
  "思",
  "怠",
  "怡",
  "急",
  "怨",
  "怪",
  "怯",
  "恆",
  "恍",
  "恕",
  "恢",
  "恤",
  "恥",
  "恨",
  "恩",
  "恭",
  "恰",
  "恿",
  "悄",
  "悅",
  "悉",
  "悔",
  "悟",
  "悠",
  "患",
  "您",
  "悴",
  "悶",
  "悼",
  "情",
  "惋",
  "惑",
  "惕",
  "惚",
  "惜",
  "惠",
  "惰",
  "惱",
  "想",
  "惶",
  "惹",
  "愁",
  "愈",
  "愉",
  "意",
  "愚",
  "愛",
  "感",
  "愧",
  "慈",
  "態",
  "慌",
  "慎",
  "慕",
  "慘",
  "慚",
  "慢",
  "慣",
  "慧",
  "慨",
  "慫",
  "慮",
  "慰",
  "慶",
  "慷",
  "慾",
  "憂",
  "憐",
  "憑",
  "憔",
  "憤",
  "憧",
  "憩",
  "憬",
  "憲",
  "憶",
  "憾",
  "懂",
  "懇",
  "懈",
  "應",
  "懊",
  "懦",
  "懲",
  "懶",
  "懷",
  "懸",
  "懼",
  "戀",
  "成",
  "我",
  "戒",
  "或",
  "戚",
  "截",
  "戰",
  "戲",
  "戴",
  "戶",
  "扁",
  "扇",
  "手",
  "才",
  "扎",
  "扒",
  "打",
  "托",
  "扛",
  "扣",
  "扭",
  "扯",
  "扶",
  "批",
  "找",
  "承",
  "技",
  "抄",
  "抉",
  "把",
  "抑",
  "抒",
  "抓",
  "投",
  "抖",
  "抗",
  "折",
  "披",
  "抱",
  "抵",
  "抹",
  "押",
  "抽",
  "拆",
  "拉",
  "拋",
  "拐",
  "拒",
  "拓",
  "拖",
  "拘",
  "拙",
  "招",
  "拜",
  "括",
  "拭",
  "拯",
  "拱",
  "拳",
  "拼",
  "拾",
  "拿",
  "持",
  "指",
  "按",
  "挑",
  "挨",
  "挪",
  "挫",
  "振",
  "挺",
  "挽",
  "挾",
  "捆",
  "捏",
  "捐",
  "捕",
  "捧",
  "捨",
  "捲",
  "捷",
  "掀",
  "掃",
  "授",
  "掉",
  "掌",
  "掏",
  "排",
  "掘",
  "掙",
  "掛",
  "掠",
  "探",
  "接",
  "控",
  "推",
  "掩",
  "措",
  "揀",
  "揉",
  "描",
  "提",
  "插",
  "揚",
  "握",
  "揣",
  "揭",
  "揮",
  "援",
  "損",
  "搏",
  "搓",
  "搗",
  "搜",
  "搞",
  "搭",
  "搶",
  "摔",
  "摘",
  "摟",
  "摧",
  "摩",
  "摯",
  "摸",
  "摺",
  "撇",
  "撈",
  "撐",
  "撒",
  "撓",
  "撕",
  "撤",
  "撥",
  "撩",
  "撫",
  "播",
  "撰",
  "撲",
  "撼",
  "撿",
  "擁",
  "擂",
  "擅",
  "擇",
  "擊",
  "擋",
  "操",
  "擎",
  "擔",
  "據",
  "擠",
  "擦",
  "擬",
  "擱",
  "擲",
  "擴",
  "擺",
  "擾",
  "攀",
  "攏",
  "攔",
  "攜",
  "攝",
  "攤",
  "攪",
  "攬",
  "支",
  "攻",
  "放",
  "政",
  "效",
  "敗",
  "敘",
  "敝",
  "敞",
  "敢",
  "散",
  "敦",
  "敷",
  "斃",
  "斑",
  "斗",
  "料",
  "斜",
  "斟",
  "斥",
  "斧",
  "斬",
  "斯",
  "新",
  "斷",
  "施",
  "旁",
  "旅",
  "旋",
  "族",
  "旗",
  "日",
  "旦",
  "旨",
  "早",
  "旬",
  "旱",
  "旺",
  "昂",
  "昆",
  "昌",
  "明",
  "易",
  "昔",
  "星",
  "映",
  "春",
  "昧",
  "昨",
  "昭",
  "是",
  "時",
  "晃",
  "晒",
  "晚",
  "晝",
  "普",
  "晰",
  "暇",
  "暈",
  "暑",
  "暖",
  "暢",
  "暫",
  "暮",
  "暴",
  "曆",
  "曉",
  "曝",
  "曠",
  "曰",
  "更",
  "書",
  "曹",
  "曾",
  "替",
  "月",
  "有",
  "朋",
  "朗",
  "望",
  "朝",
  "期",
  "朦",
  "朧",
  "未",
  "末",
  "本",
  "朱",
  "朵",
  "朽",
  "杏",
  "材",
  "杖",
  "杜",
  "束",
  "東",
  "松",
  "板",
  "枉",
  "析",
  "枕",
  "枚",
  "枯",
  "柄",
  "柏",
  "某",
  "染",
  "柔",
  "柚",
  "查",
  "柱",
  "柳",
  "柴",
  "柵",
  "栗",
  "校",
  "株",
  "核",
  "格",
  "栽",
  "框",
  "案",
  "桌",
  "桑",
  "桶",
  "桿",
  "梁",
  "梅",
  "條",
  "梨",
  "梭",
  "梯",
  "械",
  "梳",
  "棄",
  "棉",
  "棍",
  "棕",
  "棗",
  "棘",
  "棚",
  "棟",
  "森",
  "棲",
  "棵",
  "棺",
  "椅",
  "椒",
  "楊",
  "楓",
  "楚",
  "楣",
  "業",
  "楷",
  "概",
  "榜",
  "榮",
  "榷",
  "構",
  "槍",
  "槳",
  "槽",
  "樁",
  "樑",
  "樓",
  "標",
  "樸",
  "樹",
  "橋",
  "橘",
  "橙",
  "機",
  "橡",
  "橫",
  "檔",
  "檢",
  "檬",
  "檸",
  "櫥",
  "櫻",
  "欄",
  "權",
  "欲",
  "欸",
  "欺",
  "歇",
  "歉",
  "歌",
  "歎",
  "歐",
  "歡",
  "止",
  "正",
  "步",
  "歧",
  "歪",
  "歲",
  "歷",
  "歸",
  "歹",
  "死",
  "殃",
  "殊",
  "殖",
  "殘",
  "段",
  "殷",
  "殼",
  "殿",
  "毀",
  "毅",
  "毆",
  "毒",
  "毫",
  "毯",
  "氏",
  "氓",
  "氛",
  "氧",
  "水",
  "永",
  "氾",
  "汁",
  "汗",
  "池",
  "污",
  "汪",
  "汰",
  "汲",
  "決",
  "汽",
  "沃",
  "沈",
  "沉",
  "沐",
  "沒",
  "沙",
  "沛",
  "沫",
  "沮",
  "沸",
  "油",
  "治",
  "沼",
  "沾",
  "沿",
  "況",
  "泉",
  "泊",
  "法",
  "泛",
  "泡",
  "波",
  "泣",
  "泥",
  "注",
  "泰",
  "洋",
  "洗",
  "洛",
  "洞",
  "津",
  "洩",
  "洪",
  "洲",
  "洶",
  "活",
  "洽",
  "流",
  "浩",
  "浪",
  "浮",
  "浴",
  "海",
  "浸",
  "消",
  "涉",
  "涕",
  "涮",
  "涯",
  "液",
  "涵",
  "涼",
  "淆",
  "淇",
  "淋",
  "淑",
  "淒",
  "淘",
  "淚",
  "淡",
  "淤",
  "淨",
  "淪",
  "淫",
  "淵",
  "混",
  "淹",
  "添",
  "清",
  "減",
  "渠",
  "渡",
  "渣",
  "測",
  "渲",
  "渴",
  "渾",
  "湃",
  "湊",
  "湧",
  "湯",
  "溉",
  "源",
  "準",
  "溜",
  "溝",
  "溢",
  "溪",
  "溫",
  "溯",
  "溶",
  "溺",
  "滅",
  "滋",
  "滑",
  "滔",
  "滯",
  "滲",
  "滴",
  "滷",
  "漂",
  "漆",
  "漏",
  "漓",
  "漠",
  "漢",
  "漫",
  "漲",
  "漸",
  "漿",
  "潑",
  "潔",
  "潛",
  "潤",
  "潦",
  "潭",
  "潮",
  "潰",
  "澄",
  "澆",
  "澈",
  "澎",
  "澡",
  "澤",
  "澳",
  "激",
  "濁",
  "濃",
  "濕",
  "濛",
  "濟",
  "濤",
  "濫",
  "濱",
  "濺",
  "濾",
  "瀉",
  "瀑",
  "瀕",
  "瀟",
  "瀰",
  "灌",
  "灑",
  "灘",
  "灣",
  "灰",
  "灸",
  "灼",
  "災",
  "炒",
  "炫",
  "炭",
  "炮",
  "炸",
  "烈",
  "烊",
  "烏",
  "烘",
  "烤",
  "烹",
  "烽",
  "焚",
  "無",
  "焦",
  "焰",
  "然",
  "煌",
  "煞",
  "煤",
  "煥",
  "照",
  "煮",
  "熄",
  "熟",
  "熬",
  "熱",
  "燃",
  "燉",
  "燕",
  "燙",
  "營",
  "燥",
  "燦",
  "燭",
  "燴",
  "爆",
  "爍",
  "爐",
  "爛",
  "爪",
  "爬",
  "爭",
  "爵",
  "爸",
  "爽",
  "爾",
  "片",
  "版",
  "牌",
  "牠",
  "牢",
  "牧",
  "牲",
  "特",
  "牽",
  "犧",
  "犬",
  "狐",
  "狗",
  "狠",
  "狡",
  "狸",
  "狹",
  "狽",
  "猖",
  "猛",
  "猴",
  "猶",
  "猾",
  "猿",
  "獄",
  "獎",
  "獗",
  "獨",
  "獲",
  "獵",
  "獸",
  "獻",
  "玄",
  "率",
  "玫",
  "玲",
  "玻",
  "珊",
  "班",
  "現",
  "球",
  "琢",
  "琴",
  "瑕",
  "瑞",
  "瑣",
  "瑩",
  "瑰",
  "璃",
  "璧",
  "環",
  "瓜",
  "瓣",
  "瓦",
  "瓶",
  "瓷",
  "甄",
  "甘",
  "甚",
  "甜",
  "生",
  "產",
  "甥",
  "甦",
  "用",
  "甩",
  "申",
  "界",
  "畏",
  "畔",
  "留",
  "畜",
  "畢",
  "略",
  "番",
  "畫",
  "異",
  "當",
  "畸",
  "疆",
  "疊",
  "疏",
  "疑",
  "疙",
  "疚",
  "疤",
  "疫",
  "疲",
  "疵",
  "疹",
  "疼",
  "疾",
  "病",
  "症",
  "痊",
  "痔",
  "痕",
  "痘",
  "痠",
  "痣",
  "痰",
  "痴",
  "瘓",
  "瘟",
  "瘡",
  "瘤",
  "瘦",
  "瘩",
  "療",
  "癌",
  "癒",
  "癖",
  "癢",
  "癥",
  "癮",
  "癱",
  "登",
  "百",
  "皂",
  "的",
  "皆",
  "皇",
  "皮",
  "皺",
  "皿",
  "盆",
  "盈",
  "益",
  "盒",
  "盜",
  "盞",
  "盟",
  "盡",
  "監",
  "盤",
  "盧",
  "盪",
  "盯",
  "盲",
  "直",
  "相",
  "盼",
  "盾",
  "省",
  "看",
  "眠",
  "眨",
  "眷",
  "眺",
  "眼",
  "眾",
  "睏",
  "睛",
  "睜",
  "睡",
  "督",
  "睦",
  "睫",
  "睹",
  "瞄",
  "瞇",
  "瞌",
  "瞎",
  "瞞",
  "瞧",
  "瞪",
  "瞬",
  "瞭",
  "矇",
  "矗",
  "矚",
  "矛",
  "矢",
  "知",
  "矩",
  "矮",
  "矯",
  "砂",
  "研",
  "砥",
  "砲",
  "破",
  "砸",
  "硬",
  "硯",
  "碌",
  "碎",
  "碑",
  "碗",
  "碟",
  "碧",
  "碩",
  "碰",
  "碳",
  "確",
  "碼",
  "磁",
  "磅",
  "磚",
  "磨",
  "礁",
  "礙",
  "礦",
  "礪",
  "祀",
  "祈",
  "祕",
  "祖",
  "祝",
  "祟",
  "票",
  "祭",
  "祿",
  "禍",
  "禦",
  "禪",
  "禮",
  "禱",
  "禽",
  "禿",
  "秀",
  "秉",
  "秋",
  "科",
  "秒",
  "秘",
  "秤",
  "秦",
  "秩",
  "移",
  "稀",
  "稅",
  "程",
  "稍",
  "稚",
  "稠",
  "種",
  "稻",
  "稿",
  "穀",
  "積",
  "穎",
  "穩",
  "穫",
  "穴",
  "究",
  "穿",
  "突",
  "窄",
  "窒",
  "窗",
  "窘",
  "窟",
  "窩",
  "窮",
  "窺",
  "竄",
  "竅",
  "竊",
  "立",
  "站",
  "章",
  "童",
  "竭",
  "競",
  "竹",
  "竿",
  "笑",
  "笛",
  "符",
  "笨",
  "第",
  "筆",
  "等",
  "筋",
  "筍",
  "筒",
  "答",
  "策",
  "筷",
  "箏",
  "箭",
  "箱",
  "範",
  "篆",
  "篇",
  "築",
  "篩",
  "篷",
  "簡",
  "簷",
  "簽",
  "簾",
  "簿",
  "籌",
  "籍",
  "籠",
  "籤",
  "籬",
  "籲",
  "粒",
  "粗",
  "粥",
  "粵",
  "粹",
  "粽",
  "精",
  "糊",
  "糕",
  "糗",
  "糙",
  "糞",
  "糟",
  "糧",
  "糯",
  "系",
  "糾",
  "紀",
  "紊",
  "紋",
  "納",
  "紐",
  "紓",
  "純",
  "紗",
  "紙",
  "級",
  "紛",
  "素",
  "紡",
  "索",
  "紮",
  "累",
  "細",
  "紳",
  "紹",
  "絆",
  "絕",
  "絞",
  "絡",
  "給",
  "絮",
  "統",
  "綁",
  "經",
  "綜",
  "綠",
  "維",
  "綱",
  "網",
  "綴",
  "綵",
  "綻",
  "綽",
  "綿",
  "緊",
  "緒",
  "緝",
  "締",
  "緣",
  "編",
  "緩",
  "練",
  "緻",
  "縛",
  "縫",
  "縮",
  "縱",
  "總",
  "績",
  "繁",
  "繃",
  "繞",
  "繡",
  "繩",
  "繪",
  "繫",
  "繭",
  "繳",
  "繼",
  "繽",
  "續",
  "纏",
  "纖",
  "纜",
  "缸",
  "罐",
  "罕",
  "罩",
  "置",
  "罰",
  "署",
  "罵",
  "罷",
  "罹",
  "羅",
  "美",
  "羞",
  "群",
  "羨",
  "羹",
  "翁",
  "翅",
  "習",
  "翔",
  "翠",
  "翩",
  "翹",
  "翻",
  "翼",
  "耀",
  "老",
  "考",
  "者",
  "而",
  "耍",
  "耕",
  "耗",
  "耘",
  "耳",
  "耶",
  "耽",
  "聆",
  "聊",
  "聖",
  "聘",
  "聞",
  "聯",
  "聰",
  "聲",
  "聳",
  "職",
  "聽",
  "聾",
  "肅",
  "肆",
  "肉",
  "肌",
  "肖",
  "肚",
  "肝",
  "股",
  "肢",
  "肥",
  "肩",
  "肪",
  "肯",
  "育",
  "肺",
  "胃",
  "背",
  "胎",
  "胖",
  "胞",
  "胡",
  "胸",
  "能",
  "脂",
  "脅",
  "脆",
  "脈",
  "脊",
  "脖",
  "脣",
  "脫",
  "脹",
  "脾",
  "腎",
  "腐",
  "腔",
  "腕",
  "腥",
  "腦",
  "腫",
  "腰",
  "腳",
  "腸",
  "腹",
  "腿",
  "膀",
  "膊",
  "膏",
  "膚",
  "膜",
  "膝",
  "膠",
  "膨",
  "膩",
  "膿",
  "臂",
  "臉",
  "臘",
  "臟",
  "臣",
  "臥",
  "臭",
  "至",
  "致",
  "興",
  "舊",
  "舍",
  "舒",
  "舔",
  "舖",
  "舞",
  "舟",
  "航",
  "舵",
  "船",
  "艇",
  "艘",
  "艙",
  "艦",
  "良",
  "艱",
  "色",
  "芋",
  "芒",
  "芝",
  "芬",
  "芭",
  "芳",
  "芹",
  "芽",
  "苔",
  "苗",
  "苛",
  "苦",
  "英",
  "茁",
  "茂",
  "范",
  "茄",
  "茉",
  "茫",
  "茶",
  "荊",
  "荒",
  "荔",
  "荷",
  "莉",
  "莊",
  "莓",
  "莖",
  "莫",
  "莽",
  "菇",
  "菊",
  "菌",
  "菜",
  "菠",
  "菲",
  "菸",
  "萄",
  "萌",
  "萍",
  "萎",
  "萬",
  "萱",
  "葉",
  "葛",
  "葡",
  "董",
  "葬",
  "葷",
  "蒂",
  "蒙",
  "蒜",
  "蒸",
  "蒼",
  "蓄",
  "蓋",
  "蓓",
  "蓬",
  "蓮",
  "蔑",
  "蔔",
  "蔗",
  "蔣",
  "蔥",
  "蔬",
  "蔭",
  "蔽",
  "蕉",
  "蕩",
  "蕭",
  "蕾",
  "薄",
  "薑",
  "薦",
  "薪",
  "薯",
  "藉",
  "藍",
  "藏",
  "藝",
  "藤",
  "藥",
  "藹",
  "藻",
  "蘆",
  "蘇",
  "蘋",
  "蘭",
  "蘿",
  "虐",
  "虔",
  "虛",
  "虜",
  "號",
  "虧",
  "虹",
  "蚊",
  "蚤",
  "蚵",
  "蛀",
  "蛋",
  "蛙",
  "蛛",
  "蜀",
  "蜂",
  "蜘",
  "蜜",
  "蝕",
  "蝦",
  "蝴",
  "蝶",
  "蝸",
  "螂",
  "螃",
  "融",
  "螞",
  "螢",
  "蟑",
  "蟬",
  "蟲",
  "蟹",
  "蟻",
  "蠅",
  "蠟",
  "蠢",
  "蠶",
  "蠻",
  "血",
  "行",
  "衍",
  "術",
  "衛",
  "衡",
  "衫",
  "衰",
  "衷",
  "袋",
  "袍",
  "袖",
  "被",
  "袱",
  "裁",
  "裂",
  "裔",
  "裕",
  "裙",
  "補",
  "裝",
  "裡",
  "裳",
  "裸",
  "裹",
  "製",
  "複",
  "褒",
  "褪",
  "褲",
  "襟",
  "襪",
  "襯",
  "襲",
  "西",
  "要",
  "覆",
  "見",
  "規",
  "覓",
  "視",
  "覦",
  "覬",
  "覺",
  "角",
  "觸",
  "言",
  "訂",
  "計",
  "訊",
  "討",
  "訓",
  "訕",
  "託",
  "訝",
  "訟",
  "訣",
  "訪",
  "設",
  "訴",
  "註",
  "詐",
  "評",
  "詢",
  "試",
  "詭",
  "話",
  "詳",
  "誇",
  "誌",
  "認",
  "誓",
  "誕",
  "誘",
  "語",
  "誣",
  "誤",
  "誦",
  "誨",
  "說",
  "誰",
  "課",
  "誹",
  "誼",
  "調",
  "諂",
  "談",
  "請",
  "諒",
  "諜",
  "諧",
  "諮",
  "諷",
  "諸",
  "諾",
  "謀",
  "謂",
  "謊",
  "謗",
  "謙",
  "講",
  "謝",
  "謠",
  "謹",
  "譁",
  "證",
  "譏",
  "識",
  "譜",
  "警",
  "譬",
  "譯",
  "議",
  "譴",
  "護",
  "譽",
  "讀",
  "變",
  "讓",
  "谷",
  "豁",
  "豈",
  "豎",
  "豐",
  "豔",
  "豚",
  "豪",
  "豫",
  "豬",
  "豹",
  "貌",
  "貓",
  "貞",
  "貢",
  "貧",
  "販",
  "貫",
  "責",
  "貴",
  "貶",
  "買",
  "貸",
  "貿",
  "賀",
  "賂",
  "賃",
  "賄",
  "資",
  "賊",
  "賓",
  "賜",
  "賠",
  "賢",
  "賣",
  "賤",
  "賦",
  "質",
  "賭",
  "賴",
  "賺",
  "購",
  "賽",
  "贅",
  "贈",
  "贊",
  "贏",
  "贓",
  "赤",
  "赦",
  "走",
  "赴",
  "起",
  "趁",
  "超",
  "趕",
  "趙",
  "趟",
  "趣",
  "趨",
  "足",
  "趴",
  "趾",
  "跌",
  "跑",
  "跛",
  "距",
  "跡",
  "跤",
  "跨",
  "跪",
  "路",
  "跳",
  "踏",
  "踐",
  "踢",
  "踩",
  "踴",
  "蹄",
  "蹈",
  "蹟",
  "蹤",
  "蹦",
  "蹲",
  "蹺",
  "躁",
  "躍",
  "身",
  "躬",
  "躲",
  "躺",
  "軀",
  "車",
  "軌",
  "軟",
  "軸",
  "較",
  "載",
  "輒",
  "輔",
  "輕",
  "輛",
  "輝",
  "輟",
  "輩",
  "輯",
  "輸",
  "輻",
  "輾",
  "輿",
  "轄",
  "轉",
  "轍",
  "轎",
  "轟",
  "辛",
  "辜",
  "辣",
  "辦",
  "辨",
  "辭",
  "辮",
  "辯",
  "辰",
  "辱",
  "迄",
  "迅",
  "迎",
  "近",
  "返",
  "迪",
  "迫",
  "述",
  "迴",
  "迷",
  "追",
  "退",
  "送",
  "逆",
  "逍",
  "透",
  "逐",
  "逗",
  "逛",
  "逝",
  "逞",
  "速",
  "造",
  "逢",
  "逮",
  "進",
  "逸",
  "逼",
  "逾",
  "遊",
  "運",
  "遍",
  "道",
  "達",
  "違",
  "遙",
  "遛",
  "遜",
  "遞",
  "遠",
  "遣",
  "適",
  "遭",
  "遮",
  "遲",
  "遵",
  "遷",
  "選",
  "遺",
  "遼",
  "邀",
  "邁",
  "邊",
  "邏",
  "邦",
  "邪",
  "郊",
  "郎",
  "部",
  "郭",
  "都",
  "鄙",
  "鄭",
  "鄰",
  "酌",
  "配",
  "酒",
  "酗",
  "酥",
  "酬",
  "酵",
  "酷",
  "酸",
  "醇",
  "醉",
  "醋",
  "醒",
  "醜",
  "醞",
  "醫",
  "醬",
  "釀",
  "釁",
  "采",
  "釋",
  "重",
  "野",
  "釐",
  "釘",
  "釣",
  "鈍",
  "鈔",
  "鈕",
  "鈣",
  "鈴",
  "鉅",
  "鉛",
  "鉢",
  "銀",
  "銘",
  "銜",
  "銳",
  "銷",
  "鋁",
  "鋒",
  "鋼",
  "錄",
  "錢",
  "錦",
  "錫",
  "錯",
  "錶",
  "鍊",
  "鍋",
  "鍛",
  "鍵",
  "鍾",
  "鎖",
  "鏟",
  "鏡",
  "鐵",
  "鑄",
  "鑑",
  "鑰",
  "鑲",
  "鑼",
  "鑽",
  "閉",
  "閒",
  "間",
  "閣",
  "閥",
  "閩",
  "閱",
  "闆",
  "闊",
  "闖",
  "關",
  "闢",
  "阱",
  "防",
  "阻",
  "阿",
  "附",
  "陋",
  "陌",
  "降",
  "限",
  "陡",
  "院",
  "陣",
  "陪",
  "陰",
  "陵",
  "陶",
  "陷",
  "陸",
  "隆",
  "隊",
  "階",
  "隔",
  "隙",
  "際",
  "障",
  "隧",
  "險",
  "隱",
  "隸",
  "隻",
  "雀",
  "雁",
  "雄",
  "雅",
  "雇",
  "雌",
  "雕",
  "雖",
  "雙",
  "雛",
  "雜",
  "雞",
  "離",
  "難",
  "零",
  "電",
  "需",
  "震",
  "霉",
  "霍",
  "霜",
  "霞",
  "霧",
  "霸",
  "靈",
  "靜",
  "靠",
  "革",
  "靴",
  "鞋",
  "鞏",
  "鞠",
  "鞭",
  "韌",
  "韓",
  "音",
  "韻",
  "響",
  "頁",
  "頂",
  "順",
  "須",
  "頌",
  "預",
  "頑",
  "頒",
  "頓",
  "頗",
  "頰",
  "頸",
  "頹",
  "頻",
  "顆",
  "題",
  "額",
  "顏",
  "願",
  "顛",
  "顧",
  "顫",
  "顯",
  "顱",
  "颱",
  "颳",
  "飄",
  "飆",
  "食",
  "飢",
  "飩",
  "飪",
  "飯",
  "飲",
  "飼",
  "飽",
  "飾",
  "餃",
  "餅",
  "養",
  "餌",
  "餐",
  "餒",
  "餓",
  "餘",
  "餚",
  "餛",
  "餡",
  "館",
  "餵",
  "饅",
  "饋",
  "饒",
  "饗",
  "首",
  "香",
  "馨",
  "馳",
  "馴",
  "駁",
  "駐",
  "駕",
  "駛",
  "駝",
  "駭",
  "騎",
  "騙",
  "騰",
  "騷",
  "驅",
  "驕",
  "驗",
  "驚",
  "驟",
  "驢",
  "骨",
  "髒",
  "髓",
  "體",
  "高",
  "髦",
  "髮",
  "鬆",
  "鬍",
  "鬚",
  "鬥",
  "鬧",
  "鬱",
  "魁",
  "魂",
  "魄",
  "魅",
  "魏",
  "魔",
  "魚",
  "魯",
  "魷",
  "鮪",
  "鮭",
  "鮮",
  "鯨",
  "鱗",
  "鳥",
  "鳩",
  "鳳",
  "鳴",
  "鴉",
  "鴛",
  "鴦",
  "鵝",
  "鵲",
  "鶯",
  "鶴",
  "鷹",
  "鹹",
  "鹽",
  "麗",
  "麵",
  "麻",
  "麼",
  "黃",
  "黎",
  "黏",
  "默",
  "點",
  "黨",
  "黯",
  "鼓",
  "鼠",
  "鼻",
  "齋",
  "齡",
  "齣",
  "龍",
  "龐",
  "龜"
]
